import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Stack,
  Paper,
  Fade,
  Grid,
} from '@mui/material'
import localization from '../utils/localization'

function ModalHelp(props) {
  const contactItems = [
    {
      icon: 'icon-envelope',
      label: localization.strings.email,
      value: 'easypass.inc@gmail.com',
      color: '#1E88E5',
    },
    {
      icon: 'icon-friends',
      label: localization.strings.wechat,
      value: 'appmakerZXQ',
      color: '#07C160',
    },
  ]

  const promiseItems = [
    localization.strings.promiseItem1,
    localization.strings.promiseItem2,
    localization.strings.promiseItem3,
    localization.strings.promiseItem4,
  ]

  const noticeItems = [
    localization.strings.userNoticeItem1,
    localization.strings.userNoticeItem2,
  ]

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          backgroundColor: '#F8FAFC',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        {localization.strings.help}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box sx={{ mt: 2 }}>
            {/* Contact Section */}
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 800, color: '#64748B', mb: 1.5, px: 1, textTransform: 'uppercase', letterSpacing: '0.1em' }}
            >
              {localization.strings.contactUs}
            </Typography>
            <Grid container spacing={2}>
              {contactItems.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 1.5,
                      borderRadius: '16px',
                      border: '1px solid rgba(0,0,0,0.04)',
                      backgroundColor: '#fff',
                      transition: 'all 0.3s ease',
                      '&:hover': { backgroundColor: 'rgba(0,0,0,0.02)' }
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: '10px',
                          backgroundColor: `${item.color}10`,
                          color: item.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        <i className={`iconfont ${item.icon}`} style={{ fontSize: '1.1rem' }}></i>
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="caption" sx={{ color: '#94A3B8', fontWeight: 600, display: 'block', lineHeight: 1.2 }}>
                          {item.label}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            color: '#1E293B',
                            wordBreak: 'break-all',
                            fontSize: '0.8rem',
                            lineHeight: 1.3
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            <Box sx={{ height: 24 }} />

            {/* Promise Section */}
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: '20px',
                border: '1px solid rgba(0,0,0,0.04)',
                backgroundColor: '#fff',
                mb: 3,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 2, fontFamily: "'Poppins', sans-serif" }}>
                {localization.strings.easypassPromise}
              </Typography>
              <Stack spacing={1.5}>
                {promiseItems.map((text, i) => (
                  <Stack key={i} direction="row" spacing={1.5} alignItems="flex-start">
                    <Box sx={{ mt: 0.5, color: '#1E88E5' }}>
                      <i className="iconfont icon-check" style={{ fontSize: '1rem' }}></i>
                    </Box>
                    <Typography variant="body2" sx={{ color: '#475569', lineHeight: 1.6 }}>
                      {text}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Paper>

            {/* Notice Section */}
            <Box
              sx={{
                p: 3,
                borderRadius: '20px',
                backgroundColor: 'rgba(239, 68, 68, 0.05)',
                border: '1px solid rgba(239, 68, 68, 0.1)',
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#EF4444', mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                <i className="iconfont icon-lock"></i>
                {localization.strings.userNotice}
              </Typography>
              <Stack spacing={1}>
                {noticeItems.map((text, i) => (
                  <Typography key={i} variant="body2" sx={{ color: '#991B1B', opacity: 0.8, lineHeight: 1.6 }}>
                    • {text}
                  </Typography>
                ))}
              </Stack>
            </Box>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalHelp
